module.exports = __webpack_public_path__ + "img/920-0166e4.png";